import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  isEnabled: attr(Boolean),
  expandFiredItemsSectionByDefault: attr(Boolean),
  kitchenControlsFire: attr(Boolean),
  fireCoursesAfterPayment: attr(Boolean)
});